import React from "react";
import { Flex, SimpleGrid } from "@chakra-ui/react";
import { TextColumn, TextTitle } from "ui/text";
import { Section, sectionSpacingY } from "components/section";
import { SecurityBadges } from "components/security-badges";
import { Link } from "ui/link";

export function PrivacyAndComplianceFeatures() {
  return (
    <Section my="0" py={sectionSpacingY}>
      <Flex flexDir="column">
        <TextTitle size="lg" align="center" title="Secure by design" mb="biggest" />

        <SecurityBadges />

        <SimpleGrid
          columns={{ base: 1, md: 3 }}
          gap={{ base: "biggest", md: "big", lg: "bigger" }}
          mt={{ base: "biggest", md: "huge" }}
          mb={{ base: "small", lg: "big" }}
          maxW={{ base: "mediaMaxW.mobile", md: "100%" }}
        >
          <TextColumn
            title="Never store third-party data in your warehouse"
            description="You never have to store regulated third-party data in your infrastructure, and Hightouch never has to store your first-party data on our premises."
          />
          <TextColumn
            title="Easily honor opt-outs and data sharing preferences"
            description="With a few filters and field mappings, you can honor data sharing and privacy preferences from your source of truth in the warehouse, ensuring full and accurate compliance."
          />
          <TextColumn
            title="Comply with data residency laws"
            description={
              <>
                Maintain compliance with GDPR and other data residency regulations by ensuring{" "}
                <Link variant="inlineDark" href="/docs/security/storage">
                  data storage
                </Link>
                , processing, and logging are done{" "}
                <Link variant="inlineDark" href="/docs/security/regions">
                  in the appropriate region
                </Link>
                .
              </>
            }
          />
        </SimpleGrid>
      </Flex>
    </Section>
  );
}
